module.exports = __webpack_public_path__ + "static/media/11.8e331d13.png";